export const BUSINESS = {
  name: "The Drapery & Blind Co.",
  tagline: "Your One Stop Shop for Drapery & Blind Cleaning",
  phone: "(973) 489-1019",
  phoneHref: "tel:19734891019",
  email: "info@servicejersey.com",
  address: "Belleville, NJ",
  hours: "Open 24/7",
  reviewCount: "340+",
  reviewRating: "5",
  yearsExperience: "40+",
  instagram: "https://www.instagram.com/draperyandblindcleaning/",
  google: "https://www.google.com/search?q=the+drapery+and+blind+co.#lrd=0x89c25606eba06e03:0xe106d3090c6047fd,1,,,",
  website: "https://www.servicejersey.com",
};

export const LOGO_URL =
  "https://static.wixstatic.com/media/916227_fff39c2786ae4825acf470b906dc1f32~mv2.png/v1/fill/w_217,h_217,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/THE_DRAPERY_(Source_Sans).png";

export const HERO_BG =
  "https://static.wixstatic.com/media/916227_593f119d7e954f80b2e1701593043cfdf000.jpg/v1/fill/w_1280,h_527,al_c,q_85,usm_0.33_1.00_0.00,enc_avif,quality_auto/916227_593f119d7e954f80b2e1701593043cfdf000.jpg";

export const SERVICES = [
  {
    id: "drapery",
    title: "Drapery",
    description:
      "All draperies are professionally dry-cleaned at our facility and carefully rehung. We restore your window treatments to their original elegance.",
    image:
      "https://static.wixstatic.com/media/916227_b76a4f2f74dd4a9c8ffc37006b4128cc~mv2.jpg/v1/fill/w_313,h_223,al_c,q_80,usm_0.66_1.00_0.01,enc_avif,quality_auto/916227_b76a4f2f74dd4a9c8ffc37006b4128cc~mv2.jpg",
    fullDescription:
      "Our trained professionals carefully take down your draperies and transfer them to our facility. They are inspected, cleaned on both sides, steamed, and pinned to perfection before being re-hung at your convenience.",
  },
  {
    id: "blinds",
    title: "Blinds",
    description:
      "We clean all types of dirty and dusty blinds found in your home or business — from mini-blinds to vertical blinds and everything in between.",
    image:
      "https://static.wixstatic.com/media/2eb8c76e54c144e2b1b853038f224c7b.jpg/v1/fill/w_313,h_223,al_c,q_80,usm_0.66_1.00_0.01,enc_avif,quality_auto/2eb8c76e54c144e2b1b853038f224c7b.jpg",
    fullDescription:
      "We service all brands including Hunter Douglas, Graber, Levolor, Home Depot, Lowes, Blinds to Go, and more. Every blind is cleaned with care using pet-safe, odor-free chemicals.",
  },
  {
    id: "carpet",
    title: "Carpet",
    description:
      "We clean all types of wall-to-wall carpeting and area rugs using portable machines with fresh water — never recycled like truck-mounted systems.",
    image:
      "https://static.wixstatic.com/media/916227_866a9b02161548e29dc6dba20b56a90c~mv2.jpg/v1/fill/w_313,h_223,al_c,q_80,usm_0.66_1.00_0.01,enc_avif,quality_auto/916227_866a9b02161548e29dc6dba20b56a90c~mv2.jpg",
    fullDescription:
      "Our portable double-motored extractor removes maximum moisture. Clean fresh water always enters your carpet — never recycled. All chemicals are child and pet safe, leaving carpets fresh, clean and disinfected.",
  },
  {
    id: "luminettes",
    title: "Luminettes",
    description:
      "We clean all types of luminettes found in your home or business with gentle precision, preserving their delicate fabric vanes.",
    image:
      "https://static.wixstatic.com/media/916227_cd85365563e549b7a4437efc78b7501c~mv2.jpg/v1/fill/w_313,h_223,al_c,q_80,usm_0.66_1.00_0.01,enc_avif,quality_auto/916227_cd85365563e549b7a4437efc78b7501c~mv2.jpg",
    fullDescription:
      "Luminettes require specialized care. Our technicians use the proper techniques to ensure each luminette is cleaned without damage, maintaining their sophisticated appearance.",
  },
  {
    id: "silhouette",
    title: "Silhouettes",
    description:
      "We specialize in the cleaning of all types of silhouette shades, carefully preserving their signature light-filtering fabric vanes.",
    image:
      "https://static.wixstatic.com/media/916227_462e0ba59f5c40d188479b8e7e12c90f~mv2.jpg/v1/fill/w_313,h_223,al_c,q_80,usm_0.66_1.00_0.01,enc_avif,quality_auto/916227_462e0ba59f5c40d188479b8e7e12c90f~mv2.jpg",
    fullDescription:
      "Silhouette shades are a premium window treatment requiring expert handling. We specialize in restoring these delicate shades to pristine condition using specialized cleaning processes.",
  },
  {
    id: "chandelier",
    title: "Chandeliers",
    description:
      "We will clean and polish your chandelier with care and precision, restoring every crystal and fixture to sparkling brilliance.",
    image:
      "https://static.wixstatic.com/media/916227_3cb602a38cc6445a93040e2179975306~mv2.png/v1/fill/w_313,h_223,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/916227_3cb602a38cc6445a93040e2179975306~mv2.png",
    fullDescription:
      "Our chandelier cleaning service restores every crystal and fixture to sparkling brilliance. We handle all sizes and styles with the utmost care and attention to detail.",
  },
];

export const TESTIMONIALS = [
  {
    id: 1,
    name: "Ralph Hinton",
    text: "The Drapery and Blind Company did a wonderful job cleaning my blinds and drapery. They are professional, courteous and deliver excellent results. Great service from Mitchell and Emanuel. They went above and beyond. I would highly recommend their services and will definitely be using them in the future. You guys are the best!",
    rating: 5,
    image:
      "https://static.wixstatic.com/media/f9caa12505af40909b576263e6186fcd.jpg/v1/fill/w_480,h_496,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/f9caa12505af40909b576263e6186fcd.jpg",
  },
  {
    id: 2,
    name: "Martena Page",
    text: "The Drapery and Blind Company did a wonderful job cleaning my blinds and drapery. I was super impressed. They are professional, courteous and deliver excellent results. The blind looks like new. I will use your team again. Thank you.",
    rating: 5,
    image:
      "https://static.wixstatic.com/media/nsplsh_50574e784a306f65765655~mv2_d_2400_1600_s_2.jpg/v1/fill/w_480,h_496,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/nsplsh_50574e784a306f65765655~mv2_d_2400_1600_s_2.jpg",
  },
  {
    id: 3,
    name: "Sandra Williams",
    text: "Absolutely phenomenal service. They cleaned my Hunter Douglas blinds and the results were beyond my expectations. Professional team, on time, and the quality of their work speaks for itself. Highly recommended for anyone in New Jersey.",
    rating: 5,
    image:
      "https://static.wixstatic.com/media/916227_a23f4fd513164f6fabccddbe52f4d77a~mv2.jpg/v1/fill/w_170,h_170,al_c,q_80,usm_0.66_1.00_0.01,enc_avif,quality_auto/IMG_20190605_230003_535.jpg",
  },
];

export const SERVICE_AREAS = [
  "Newark, NJ", "Jersey City, NJ", "Hoboken, NJ", "Bayonne, NJ",
  "East Orange, NJ", "Union City, NJ", "Clifton, NJ", "Paterson, NJ",
  "Hackensack, NJ", "Passaic, NJ", "Elizabeth, NJ", "Trenton, NJ",
  "Camden, NJ", "Cherry Hill, NJ", "Edison, NJ", "Piscataway, NJ",
  "Woodbridge, NJ", "Lakewood, NJ", "Toms River, NJ", "Atlantic City, NJ",
  "Manhattan, NY", "Brooklyn, NY", "Queens, NY", "The Bronx, NY",
  "Staten Island, NY", "Westchester County, NY",
  "Philadelphia, PA", "Connecticut",
];

export const PROCESS_STEPS = [
  {
    step: "01",
    title: "Free Consultation",
    description:
      "Call us at (973) 489-1019 for a free estimate. We assess your window treatments and provide an accurate, honest quote.",
  },
  {
    step: "02",
    title: "Professional Pickup",
    description:
      "Our trained team arrives on schedule, carefully takes down your treatments, and transports them to our facility — with no trip charge.",
  },
  {
    step: "03",
    title: "Expert Cleaning",
    description:
      "At our facility, every item is inspected, cleaned on both sides, and treated with pet-safe, odor-free solutions to perfection.",
  },
  {
    step: "04",
    title: "Reinstallation",
    description:
      "Your freshly cleaned treatments are returned, steamed, and rehung at your convenience. We install temporary shades at no cost.",
  },
];

export const WHY_US = [
  { icon: "ri-star-fill", title: "340+ Five-Star Reviews", desc: "Over 340 verified Google reviews from satisfied customers across NJ, NY, PA & CT." },
  { icon: "ri-time-fill", title: "Open 24/7", desc: "We're available around the clock, including emergency cleanups for water, fire, or other damage." },
  { icon: "ri-shield-check-fill", title: "Fully Insured", desc: "Completely insured with liability and worker's comp insurance for your total peace of mind." },
  { icon: "ri-leaf-fill", title: "Eco-Friendly", desc: "All chemicals are child-safe, pet-safe, and leave absolutely no odor residue." },
  { icon: "ri-truck-fill", title: "Free Pickup & Delivery", desc: "Professional pickup and delivery with no trip charge. We also accept shipped items." },
  { icon: "ri-award-fill", title: "40+ Years Experience", desc: "Decades of expertise cleaning draperies, blinds, carpets, chandeliers and more." },
];

export const WORK_EXAMPLES = [
  "https://static.wixstatic.com/media/916227_d7a927157a6148c1aff4d9719d00f0d1~mv2.jpg/v1/fill/w_704,h_938,q_90,enc_avif,quality_auto/916227_d7a927157a6148c1aff4d9719d00f0d1~mv2.jpg",
  "https://static.wixstatic.com/media/916227_a6ee703312a34306a13d6d56bcc0fce4~mv2.jpg/v1/fill/w_704,h_938,q_90,enc_avif,quality_auto/916227_a6ee703312a34306a13d6d56bcc0fce4~mv2.jpg",
  "https://static.wixstatic.com/media/916227_462e0ba59f5c40d188479b8e7e12c90f~mv2.jpg/v1/fill/w_704,h_938,q_90,enc_avif,quality_auto/916227_462e0ba59f5c40d188479b8e7e12c90f~mv2.jpg",
  "https://static.wixstatic.com/media/916227_c540b24c96884463a9685f9d4cd9da56~mv2.jpg/v1/fill/w_388,h_388,al_c,q_80,usm_0.66_1.00_0.01,enc_avif,quality_auto/IMG_20190324_190320_445.jpg",
  "https://static.wixstatic.com/media/916227_3f2e5156be4145c5bb40dd02567444b3~mv2.jpg/v1/fill/w_388,h_388,al_c,q_80,usm_0.66_1.00_0.01,enc_avif,quality_auto/IMG_20190415_174425_557_edited.jpg",
  "https://static.wixstatic.com/media/916227_f086a1a54d6640479349ccdff3e24ee3~mv2.jpg/v1/fill/w_388,h_388,al_c,q_80,usm_0.66_1.00_0.01,enc_avif,quality_auto/20170730_163852.jpg",
];

export const FAQS = [
  {
    question: "Who provides professional drapery cleaning near me in New Jersey?",
    answer:
      "The Drapery & Blind Co. provides professional drapery cleaning throughout New Jersey, New York, Pennsylvania, and Connecticut. We serve over 40 cities including Newark, Jersey City, Hoboken, and more. Call (973) 489-1019 for service in your area.",
  },
  {
    question: "How much does drapery and blind cleaning cost?",
    answer:
      "We provide free, accurate estimates for every job — no two projects are the same and we don\'t believe in one-price-fits-all. Pricing depends on the type, size, and condition of your treatments. Call (973) 489-1019 or submit a quote request for a personalized estimate.",
  },
  {
    question: "How long does drapery cleaning take?",
    answer:
      "Most drapery and blind cleaning projects are completed and returned within a reasonable timeframe. We take down your treatments, clean them at our facility, and rehang them at your convenience. We also install temporary shades at no cost so your windows are never left bare.",
  },
  {
    question: "Do you offer free pickup and delivery for drapery cleaning?",
    answer:
      "Yes! Our professional pickup and delivery service includes no trip charge. We take down your window treatments, transport them to our facility for thorough cleaning, and return them freshly cleaned and rehung — all at no extra cost.",
  },
  {
    question: "Are your cleaning products safe for children and pets?",
    answer:
      "Absolutely. All of our cleaning chemicals are 100% child-safe and pet-safe, and they leave zero odor residue. We prioritize eco-friendly solutions that clean effectively without any health risks to your family.",
  },
  {
    question: "How long has The Drapery & Blind Co. been in business?",
    answer:
      "The Drapery & Blind Co. has been serving New Jersey and the surrounding area for over 40 years. With more than 340 five-star Google reviews, we are the region\'s most trusted name in professional drapery, blind, and carpet cleaning.",
  },
];
